import { v4 as uuidv4 } from "uuid";
import Bookmark from "@arcgis/core/webmap/Bookmark";

export const identifyWebMapBookMarks = (bookmarks: any) => {
  if (bookmarks.length) {
    bookmarks.forEach((bookmark) => {
      bookmark.source = "webmap";
    });
  }
};

export const loadBookmarksFromLocalStorage = (bookmarks: any,mapId) => {
  const localStorageBookmarks = JSON.parse(localStorage.getItem(`bookmarks-${mapId}`));
  try {
    if (localStorageBookmarks) {
      const newBookMarksArray = localStorageBookmarks.map((item) => {
        const { spatialReference, xmax, xmin, ymax, ymin } =
          item.viewpoint.targetGeometry;
        let newBookmark: any = new Bookmark({
          name: item.name,
        });
        newBookmark.viewpoint = {
          rotation: item.viewpoint.rotation,
          scale: item.viewpoint.scale,
          targetGeometry: {
            spatialReference: spatialReference,
            xmax: xmax,
            xmin: xmin,
            ymax: ymax,
            ymin: ymin,
            type: "extent",
          },
        };

        newBookmark.source = "local storage";
        newBookmark.localStoreUUID = item.localStoreUUID;
        return newBookmark;
      });
      bookmarks.addMany(newBookMarksArray);
    } else {
      localStorage.setItem(`bookmarks-${mapId}`, JSON.stringify([]));
    }
  } catch (e) {
    console.error("failed to load bookmarks from local storage");
    console.error(e)
  }
};

export const bookmarkEventHandlers = (widget: any,mapId) => {
  const { bookmarks } = widget;

  bookmarks.on(["after-add", "after-remove"], (e) => {
    bookmarkChangeEvent(e,mapId);
  });

  widget.on("bookmark-edit", (e) => onEditHandler(e,mapId));
};

const onEditHandler = (e: any,mapId) => {
  const localStorageBookmarks = JSON.parse(localStorage.getItem(`bookmarks-${mapId}`));
  if (localStorageBookmarks) {
    let bookmarks = [];
    localStorageBookmarks.forEach((item) => {
      if (item.source === "local storage") {
        if (item.localStoreUUID === e.bookmark.localStoreUUID) {
          let newBookmark: any = {
            viewpoint: e.bookmark.viewpoint,
            name: e.bookmark.name,
          };
          newBookmark.source = "local storage";
          newBookmark.localStoreUUID = item.localStoreUUID;
          bookmarks.push(newBookmark);
        } else {
          bookmarks.push(item);
        }
      }
    });
    localStorage.setItem(`bookmarks-${mapId}`, JSON.stringify(bookmarks));
  }
};

const bookmarkChangeEvent = (e: any,mapId) => {
  if (e.target) {
    const { target } = e;
    let bookmarks = [];
    target.items.forEach((item) => {
      const { spatialReference, xmax, xmin, ymax, ymin } =
        item.viewpoint.targetGeometry;

      if (item.source === "webmap") {
      } else {
        if (item.source === "local storage") {
          let bookmark: any = {
            name: item.name,
            extent: item.extent,
          };
          bookmark.localStoreUUID = item.localStoreUUID;
          bookmark.source = item.source;
          bookmark.viewpoint = {
            rotation: item.viewpoint.rotation,
            scale: item.viewpoint.scale,
            targetGeometry: {
              spatialReference: spatialReference,
              xmax: xmax,
              xmin: xmin,
              ymax: ymax,
              ymin: ymin,
              type: "extent",
            },
          };
          bookmarks.push(bookmark);
        } else if ("source" in item === false) {
          let bookmark: any = {
            name: item.name,
            extent: item.extent,
          };

          bookmark.localStoreUUID = uuidv4();
          bookmark.source = "local storage";
          bookmark.viewpoint = {
            rotation: item.viewpoint.rotation,
            scale: item.viewpoint.scale,
            targetGeometry: {
              spatialReference: spatialReference,
              xmax: xmax,
              xmin: xmin,
              ymax: ymax,
              ymin: ymin,
              type: "extent",
            },
          };
          bookmarks.push(bookmark);
        }
      }
    });
    localStorage.setItem(`bookmarks-${mapId}`, JSON.stringify(bookmarks));
  }
};
